import React, { forwardRef } from "react";
import { Row, Col } from "antd";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import { InputItem } from "../../../components/forms/FormItems";
import Spacer from "../../../components/layouts/Spacer";
import SwitchItem from "../../../components/forms/SwitchItem";
import FormHeader from "../../../components/forms/FormHeader";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useParams, useLocation } from "react-router-dom";

const staffFilter = { filter: { $and: [{ staff_member: true }] } };

const AdditionalDetails = forwardRef((props, ref) => {
  const { activeEmployee } = props;
  let { branchId } = useParams();
  const location = useLocation();
  const isAdmin = location.pathname.includes("admin");

  const changedValues = useSelector(
    (state) => state.employeeDetails.changedItems.values
  );
  const intl = useIntl();

  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.employees.additionalInformation" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem name="has_license" category="employee" />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SwitchItem name="has_car" category="employee" />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="care_giver"
                  category="employee"
                  itemRules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const iSstaffMember =
                          changedValues.staff_member !== undefined
                            ? changedValues.staff_member
                            : activeEmployee.staff_member;
                        if (value || iSstaffMember) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            intl.formatMessage({
                              id: "app.forms.employee.staff_or_worker",
                            })
                          )
                        );
                      },
                    }),
                  ]}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="staff_member"
                  category="employee"
                  itemRules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const iSworker =
                          changedValues.care_giver !== undefined
                            ? changedValues.care_giver
                            : activeEmployee.care_giver;
                        if (value || iSworker) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            intl.formatMessage({
                              id: "app.forms.employee.staff_or_worker",
                            })
                          )
                        );
                      },
                    }),
                  ]}
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="interested_in_several_scheduling"
                  category="employee"
                />
              </div>
              <div style={{ flex: 1 }}>
                <SwitchItem name="religious" category="employee" />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="max_monthly_hours"
                  category="employee"
                  number={true}
                  min={0}
                  max={744}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <EmployeesSelect
                  name="staff_worker_in_charge_id"
                  category="employee"
                  waitForFetch={
                    !activeEmployee || !activeEmployee.active_branches
                  }
                  extraParams={{
                    ...staffFilter,
                    scopePrefix: isAdmin ? `` : `branches/${branchId}/`,
                  }}
                  items={
                    activeEmployee?.id &&
                    activeEmployee.staff_worker_in_charge && [
                      activeEmployee.staff_worker_in_charge,
                    ]
                  }
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="work_in_other_company"
                  category="employee"
                  trueFalse={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default AdditionalDetails;
